import dailyCashAdvance from '@/api/expense/daily-cash-advance'
import moment from 'moment'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
	...baseState,
	dateRange: [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')]
}

export const getters = {}

export const mutations = {
	...baseMutations,
	SET_DATE_RANGE(state, date) {
		state.dateRange = date
	},
}

export const actions = {
	fetch(context, attrubutes = {}) {
		let params = Object.assign(
			{
				page: context.state.pagination.page,
				perPage: context.state.pagination.perPage,
				branch_id: context.state.branch_id,
				filter: {
					search: context.state.search,
					date_between: _.join(context.state.dateRange, ',')
				}
			},
			attrubutes
		)
		return dailyCashAdvance.get({ params }).then(response => {
			context.commit('RECEIVE_RESOURCES', response)
			return Promise.resolve(response)
		})
	},
	store(context, data) {
		return dailyCashAdvance.store(data)
	},
	update(context, { id, data }) {
		return dailyCashAdvance.update(id, data)
	},
	destroy(context, { id, data }) {
		return dailyCashAdvance.destroy(id, data)
	},
	toPdf(context, id) {
		return dailyCashAdvance.toPdf(id)
	},
	async getPaymentMethod(context) {
		return await dailyCashAdvance.paymentMethod()
	},
	async getBankProfile(context) {
		return await dailyCashAdvance.bankProfile()
	},
	async getEmployee(context) {
		return await dailyCashAdvance.employee()
	},
	async getCurrency(context) {
		return await dailyCashAdvance.currency()
	},
}